/* eslint-disable import/prefer-default-export */
import React from 'react';

export const Spinner = () => <div className="spinner-border" />;
export const SpinnerSmall = () => (
  <div className="spinner-border" style={{ width: '1rem', height: '1rem' }} />
);
